import React, { useEffect, useRef, useState } from 'react';
import Hls from 'hls.js';

export default function SteamVideo({ src, poster, title, steamUrl }) {
  const videoRef = useRef(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    setFailed(false);
    let hls;
    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = src;
    } else if (Hls.isSupported()) {
      hls = new Hls();
      hls.loadSource(src);
      hls.attachMedia(video);
      hls.on(Hls.Events.ERROR, (_, data) => {
        if (data.fatal) setFailed(true);
      });
    } else {
      setFailed(true);
    }
    return () => {
      hls?.destroy();
      video.removeAttribute('src');
      video.load();
    };
  }, [src]);

  return (
    <div className="relative w-full h-full bg-black">
      <video
        ref={videoRef}
        poster={poster}
        aria-label={title}
        controls
        playsInline
        preload="none"
        className="w-full h-full object-contain"
        onError={() => setFailed(true)}
      />
      {failed && (
        <a href={steamUrl} target="_blank" rel="noopener noreferrer"
          className="absolute inset-0 flex items-center justify-center bg-black/80 text-arcade-cyan underline">
          {title} — Steam ↗
        </a>
      )}
    </div>
  );
}
